import { formatEther } from "viem";

export const calcPercBigNumber = (number: bigint, percent: number) => {
  const percentageAmount = (number * BigInt(percent)) / BigInt(100);
  return formatEther(percentageAmount);
};
